module.exports = __webpack_public_path__ + "static/img/7.ed7c1949.png";